import React, { useState } from 'react'
import ReactQuill from 'react-quill-new'
//import 'react-quill-new/dist/quill.snow.css'

interface TextEditorProps {
  editorValue: string
  isUpdate:boolean
  setEditorValue: React.Dispatch<React.SetStateAction<string>>
}

const PatchedReactQuill: React.FC<TextEditorProps> = ({
  editorValue,
  setEditorValue,
  isUpdate
}) => {
  const handleEditorChange = (value: string) => {
    setEditorValue(value)
  }
  return (
    <div style={{ width: '100%', paddingRight: '10px', marginBottom: '40px' }}>
      <ReactQuill
        value={editorValue}
        onChange={handleEditorChange}
        style={{ height: "200px" }}
        readOnly={isUpdate}
        modules={{
          toolbar: [
            [{ header: '1' }, { header: '2' }, { font: [] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['bold', 'italic', 'underline'],
            ['link'],
            // ['image'],
            [{ align: [] }],
            ['clean'],
            [{ color: [] }, { background: [] }]
          ],
          // keyboard: {
          //   bindings: {
          //     // Override the default Enter behavior
          //     customEnter: {
          //       key: 13, // Enter key
          //       handler: function (range, context) {
          //         const quill = this.quill;
          //         quill.insertEmbed(range.index, 'break', true);
          //         quill.setSelection(range.index + 1, 0);
          //         return false;
          //       }
          //     }
          //   }
          // }
        }}
      />
    </div>
  )
}

export default PatchedReactQuill